const inputTextLimit = 100;
const textAreaLimit = 250;

export { inputTextLimit, textAreaLimit }